export function removeScrollOnScrim() {
    const element = document.body.clientHeight !== document.body.scrollHeight ? document.body : document.documentElement;
    const scrollbarWidth = window.innerWidth - element.clientWidth;
    const documentComputedStyle = getComputedStyle(element);
    const initialRightPadding = documentComputedStyle.getPropertyValue("padding-right");

    const initialDocumentStyle = {
        overflow: documentComputedStyle.overflow,
        paddingRight: initialRightPadding,
    };

    Object.assign(element.style, {
        overflow: "hidden",
        paddingRight: `${parseFloat(initialRightPadding) + scrollbarWidth}px`
    });
    return {
        scrollbarWidth,
        restore: () => Object.assign(element.style, initialDocumentStyle),
    };
}
